import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Estimatetax = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Estimated Tax Payments</h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Stay Ahead of Tax Season with Estimated Tax Planning
          </h1>
          <p className="tax-section-description">
            For many taxpayers, especially those who are self-employed or earn
            income outside of traditional wages, estimated tax payments are a
            critical part of staying compliant with IRS requirements. At
            Easy Tax Experts , we make managing these payments simple and
            stress-free, helping you avoid unexpected bills and penalties.
          </p>

          <h2 className="tax-subheading">What Are Estimated Tax Payments?</h2>
          <p className="tax-section-description">
            Estimated tax payments are quarterly prepayments made to the IRS to
            cover income tax on earnings not subject to regular withholding.
            They typically apply to:
          </p>
          <ul className="tax-section-description">
            <li>Self-employed professionals and freelancers</li>
            <li>Small business owners</li>
            <li>
              Investors with income from dividends, capital gains, or rental
              properties
            </li>
            <li>
              Individuals with side jobs or additional income outside W-2 wages
            </li>
          </ul>

          <h2 className="tax-subheading">Why Are They Important?</h2>
          <p className="tax-section-description">
            If you expect to owe <strong>$1,000 or more</strong> when filing
            your return, the IRS requires quarterly estimated payments. Missing
            or underpaying can lead to costly penalties. With our guidance,
            you’ll stay compliant while minimizing what you owe.
          </p>

          <h2 className="tax-subheading">How We Help You Manage Payments</h2>
          <ol className="tax-section-description">
            <li>
              <strong>Accurate Liability Calculations:</strong> We project your
              income, deductions, and credits to determine the right payment
              amount.
            </li>
            <li>
              <strong>Clear Payment Schedule:</strong> We keep you on track with
              IRS deadlines:
              <ul>
                <li>April 15 – 1st Quarter</li>
                <li>June 15 – 2nd Quarter</li>
                <li>September 15 – 3rd Quarter</li>
                <li>January 15 (following year) – 4th Quarter</li>
              </ul>
            </li>
            <li>
              <strong>Convenient Payment Options:</strong> We guide you through
              methods like IRS Direct Pay, EFTPS, or checks.
            </li>
            <li>
              <strong>Adjustments for Life Events:</strong> If your income
              changes mid-year, we’ll recalculate to keep you penalty-free.
            </li>
            <li>
              <strong>Organized Record-Keeping:</strong> Maintain clear records
              of all payments to simplify your year-end filing.
            </li>
          </ol>

          <h2 className="tax-subheading">Common Mistakes to Avoid</h2>
          <ul className="tax-section-description">
            <li>Waiting until April to pay instead of quarterly</li>
            <li>
              Using last year’s numbers without adjusting for income changes
            </li>
            <li>Missing deadlines and incurring penalties</li>
            <li>Not tracking payments properly for tax filing</li>
          </ul>

          <h2 className="tax-subheading">Why Choose Easy Tax Experts ?</h2>
          <p className="tax-section-description">
            We provide personalized, expert assistance so you never have to
            stress about deadlines or penalties again. From calculating your
            quarterly payments to adjusting for life changes, our team ensures
            you stay compliant and financially prepared.
          </p>

          <p className="tax-section-description">
            Take control of your tax planning—contact Easy Tax Experts  today
            and let us streamline your estimated tax payments so you can focus
            on growing your income with confidence.
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Estimatetax;
